<template lang="html">
<div class="pgInner announcement">

    <div class="headBar">新建 BANNER</div>

    <div class="pgbody" :style="'height:' + pageH + 'px;'">
         <el-scrollbar ref="scroller" style="height:100%;">

           <el-form ref="ruleForm" :model="params" :rules="rules" inline-message="true" :show-message="false">

               <div class="tabContent">

                 <div class="text-block clearfix">
                     <div class="bName">标题</div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-input size="medium" class="inpText" v-model="params.name" placeholder="请输入活动标题"></el-input>
                           </el-form-item>
                     </div>
                 </div>


                 <div class="text-block clearfix">
                     <div class="bName">图片</div>
                     <div class="bContent">
                           <img-upload :image="params.imageId" @imgChange="imgChange" tips="( 375*180 推荐 )" />
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">跳转类型</div>
                     <div class="bContent">
                           <el-form-item prop="title">
                              <el-select v-model="params.type" @change="typeChange" placeholder="请选择">
                                <el-option
                                  v-for="item in options"
                                  :key="item.value"
                                  :label="item.text"
                                  :value="item.value">
                                </el-option>
                              </el-select>
                           </el-form-item>
                     </div>
                 </div>

                 <div v-if="params.type == 1" class="text-block clearfix">
                     <div class="bName">
                        <span>链接地址</span>
                     </div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-input size="medium" class="inpText" v-model="params.url"></el-input>
                           </el-form-item>
                     </div>
                 </div>

                 <div v-if="params.type > 1" class="text-block clearfix">
                     <div class="bName">
                        <span>关联内容</span>
                     </div>
                     <div class="bContent">
                           <el-form-item prop="title">
                             <el-select
                               v-model="params.url"
                               filterable
                               remote
                               placeholder="请输入关键词"
                               size="medium"
                               @change="selectChange"
                               :remote-method="goSeek"
                               :loading="loading">
                               <el-option
                                 v-for="item in selectArr"
                                 :key="item.id"
                                 :label="item.title"
                                 :value="item.id">
                               </el-option>
                             </el-select>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">排序</div>
                     <div class="bContent">
                           <el-form-item prop="title">
                               <el-input-number v-model="params.sort"></el-input-number>
                           </el-form-item>
                     </div>
                 </div>

                 <div class="text-block clearfix">
                     <div class="bName">是否发布</div>
                     <div class="bContent">
                           <el-form-item prop="title">
                              <el-radio-group v-model="params.status">
                                  <el-radio :label="1">是</el-radio>
                                  <el-radio :label="2">否</el-radio>
                              </el-radio-group>
                           </el-form-item>
                     </div>
                 </div>

               </div>

            </el-form>

         </el-scrollbar>
    </div>

    <div class="pagefoot">

        <el-button @click="directSave(1)" type="primary" size="small">确定</el-button>
        <el-button @click="goReturn" plain size="small">取消</el-button>

    </div>

</div>
</template>

<script>
import { bannerSave,bannerEdit } from "@/api/banner/index";
import { pocList } from "@/api/policies/policies";
import { affList } from "@/api/affairs/affairs";
import { msgList } from "@/api/message/message";
import { dicSeek } from "@/api/pgMent/dictMent";
export default {
    computed:{
        lineStr:function(){
            var str = '';
            if(this.navAct === 0 || this.navAct == 4){
               str = 'width:60px;';
            }else {
               str =  'width:30px;';
            }

            str = str + "left:" + this.navX + "px;";

            return str;
        }
    },
    data(){
        return{

            pageH:'',

            options:[
               { text:'H5页面',value:1 },
               { text:'申报',value:2 },
               { text:'政策',value:3 },
               { text:'政务',value:4 },
               { text:'活动速递',value:5 },
               { text:'产品集市',value:6 },
               { text:'服务广场',value:7 },
               { text:'办公选址',value:8 },
               { text:'商协会',value:9 },
            ],

            params:{
                id:'',
                name:'',
                imageId:'',
                url:'',
                description:'',
                status:2,
                type:'',
                sort:'',
            },

            selectArr:[],
            loading:false,
            sxMap:{},
            keyword:'',

            rules:{
                name:[{
                      required: true,
                      message: '不能为空',
                      trigger: 'blur'
                }],
                type:[{
                      required: true,
                      message: '不能为空',
                      trigger: 'blur'
                }],
                sort:[{
                      required: true,
                      message: '不能为空',
                      trigger: 'blur'
                }],
            }

        }
    },

    methods:{

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 205;
        },

        goCreate:function(){  // 创建
            var vues = this;
            bannerSave({banner:this.params}).then(res => {
                vues.$router.push('banner_list');
            }).catch(errr => {});
        },

        tmSave:function(){
            var vues = this;
            this.waitSave = setInterval(function(){
                var nowCode = JSON.stringify(vues.params);
                if(nowCode !== vues.preCode){
                    vues.goCreate(2);
                    vues.preCode = nowCode;
                }
            },60000)
        },

        typeChange:function(){
            if(this.params.type > 1){
                this.params.url = '';
                this.goSeek();
            }
        },

        selectChange:function(){
           var vues = this;
           this.selectArr.forEach(item => {
              if(item.id == vues.params.url){
                  vues.params.description = item.title;
                  return false;
              }
           })
        },

        goSeek:function(e){
            let pms = {
                size:12,
                no:1
            }
            this.keyword = e;
            let vues = this;
            if(this.params.type == 2 || this.params.type == 3 ){
                pms.declarationPolicyCondition = {
                    keyword:e || ''
                }
                vues.loading = true;
                pocList(pms).then(res => {
                    vues.loading = false;
                    vues.selectArr = res.declarationPolicyList;

                })
            }else if(this.params.type == 4){
                vues.loading = true;
                pms.keyword = e || '';
                affList(pms).then(res => {
                    vues.loading = false;
                    vues.selectArr = res.handleMattersList;
                })
            }else{
                vues.loading = true;
                pms.keyword = e || '';
                pms.businessNewsTypeId = vues.sxMap[this.params.type - 4];
                if(pms.businessNewsTypeId){
                    msgList(pms).then(res => {
                        vues.loading = false;
                        vues.selectArr = res.businessNewsList;
                    })
                }else{
                    vues.$message.error('初始化未完成，请稍后重试！');
                }
            }
        },

        directSave:function(){
            var vues = this;
            this.$refs.ruleForm.validate((valid) => {
                if(valid){
                    if(!vues.params.imageId){
                        vues.$message.error('请上传banner图');
                    }else if(!vues.params.url){
                        if(vues.params.type == 1){
                            vues.$message.error('请填写跳转链接');
                        }else{
                            vues.$message.error('请填写内容Id');
                        }
                    }else{
                        vues.goCreate();
                    }
                }
            })
        },

        imgChange:function(e){
            this.params.imageId = e;
        },

        goReturn:function(){
            this.$router.push('banner_list');
        },

        prevSet:function(){

            var vues = this;
            var querys = this.$route.query;
            this.params.type = querys.typeid;

            // 底部定位
            this.pageFix();

            if(querys && querys.id){
                this.params.id = querys.id;
                bannerEdit({id:querys.id}).then(res => {
                    vues.params = res.banner;
                    if(vues.params.type > 1){
                        vues.goSeek(res.banner.description);
                    }
                })
            }else{
                this.preCode = JSON.stringify(this.params);
                // this.tmSave();
            }

        }
    },
    created:function(){
        var vues = this;


        $(window).on('resize',function(){
    		     vues.pageFix();
             vues.$refs.scroller.$data.sizeHeight = this.pageH;
    	  })

        dicSeek({code:'shangx'}).then(res => {
             var unFormate = res.dataDictionarys;
             unFormate.forEach(item => {
                 vues.sxMap[item.sort] = item.id;
             });
             this.prevSet();
        })

    },

    beforeDestroy:function(){
        $(window).off('resize');
        // clearInterval(this.waitSave);
    }


}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.headBar{
  height: 55px;
  line-height: 55px;
  font-size: 16px;
  padding-left: 20px;
  background: white;
}

.pgbody{
  margin: 20px;
}

.tabNavs{
  height: 50px;
  padding-left: 15px;
  background: white;
  position: relative;
  .tabItem{
     float: left;
     height: 50px;
     line-height: 50px;
     font-size: 15px;
     margin-right: 45px;
     cursor: pointer;
  }
  .tabItem.act{
    color: rgb(86, 119, 252);
  }
  .moveLine{
    height: 2px;
    background: rgb(86, 119, 252);
    position: absolute;
    bottom: 0px;

    transition-property: all;
    transition-duration: 0.2s;
  }
}

.tabContent{
  padding: 20px;
  background: white;
}

.pagefoot{
  height: 60px;
  line-height: 60px;
  background: white;
  padding-left: 20px;
  position: relative;
  z-index: 2;
  .btn{
    height: 32px;
    padding: 0 12px;
    margin-right: 12px;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
  }
  .type1{
    line-height: 32px;
    background: rgb(86, 119, 252);
    color: white;
  }
  .type2{
    box-sizing: border-box;
    border: 1px solid #aeaeae;
    line-height: 30px;
  }
}

.text-block{
      font-size: 14px;
     .bName{
          width: 90px;
          padding-top: 8px;
          float: left
     }
     .bContent{
          margin-left: 90px;
          position: relative;
          margin-bottom: 20px;

          .inpText{
               width: 420px;
          }
     }

}

.enclosure{
   margin-top: 20px;
   margin-bottom: 45px;
  .ttl{
    float: left;
    height: 32px;
    line-height: 32px;
    font-size: 15px;
  }
  .ecContent{
    margin-left: 60px;
  }

}

</style>

<style lang="css">

.announcement .el-input__inner{
    border-radius: 0px;
}

</style>



// WEBPACK FOOTER //
// bannerEdit.vue?d5d054f6